<canvas
  #canvas
  [width]="canvasWidth"
  class="color-slider rounded my-4"
  height="20"
  (mousedown)="onMouseDown($event)"
  (mousemove)="onMouseMove($event)"
>
</canvas>
<!--  class="color-slider rounded transform rotate-90"-->
